export default __webpack_public_path__ + "static/media/fullUpdated.53979e87.png";